import { Component, OnInit, ViewChild, TemplateRef, Inject } from '@angular/core'
import { I18NService } from '@core'
import { STColumn, STComponent, STData } from '@delon/abc/st'
import { _HttpClient, ALAIN_I18N_TOKEN } from '@delon/theme'
import { NzModalService } from 'ng-zorro-antd/modal'

import questions from './questions.json'

@Component({
  selector: 'app-support-question',
  templateUrl: './question.component.html',
})
export class SupportQuestionComponent implements OnInit {
  @ViewChild('st') private readonly st!: STComponent
  datalist: STData[] = []
  columns: STColumn[] = [
    { title: this.i18n.fanyi('app.common.title'), index: 'name', render: 'nameTpl' },
  ]
  title: string = ''
  answer: string = ''

  showFile(title: any): void {
    // this.modal.info({
    //   nzTitle: title,
    //   nzIconType: '',
    //   nzContent: questions.find((item: any) => item.title == title).answer,
    //   nzOnOk: () => {},
    // })
  }

  createTplModal(
    tplTitle: TemplateRef<{}>,
    tplContent: TemplateRef<{}>,
    tplFooter: TemplateRef<{}>,
    title: any,
  ): void {
    this.title = title
    this.answer = questions.find((item: any) => item.title == title).answer
    this.modal.create({
      nzWidth: 600,
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: false,
      nzClosable: false,
      nzOnOk: () => console.log('Click ok'),
    })
  }

  constructor(
    private http: _HttpClient,
    private modal: NzModalService,
    @Inject(ALAIN_I18N_TOKEN) protected i18n: I18NService,
  ) {}

  ngOnInit(): void {
    this.datalist = questions.map((item: any) => ({
      ...item,
    }))
  }
}
